// extracted by mini-css-extract-plugin
module.exports =  {"gwMediaSidebarWrapper":"MediaSideBar_gwMediaSidebarWrapper__-zfq9","player":"MediaSideBar_player__4X8yB"};